module.exports = __webpack_public_path__ + "static/media/bear-and-door.89504e4a.gif";